module.exports = __webpack_public_path__ + "img/ky8.620715d7.png";